import Vue from 'vue';
import Vuex from 'vuex';

import { AuthenticationVuexModule } from '@icabbi/vue-authentication';

import authManagerStore from './modules/authManagerStore';
import globalMessages from './modules/globalMessages';
import language from './modules/language';
import stripe from './modules/stripe';
import paymentOnboarding from './modules/paymentOnboarding';
import bankingAccount from './modules/bankingAccount';
import bookingChannel from './modules/bookingChannel';
import disputes from './modules/disputes';
import charges from './modules/charges';
import csvReport from './modules/csvReport';
import users from './modules/users';
import driverStates from './modules/driverStates';
import payouts from './modules/payouts';
import fleets from './modules/fleets';
import utils from './modules/utils';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    authentication: AuthenticationVuexModule,
    authManager: authManagerStore,
    bankingAccount,
    bookingChannel,
    charges,
    csvReport,
    disputes,
    globalMessages,
    language,
    paymentOnboarding,
    stripe,
    users,
    driverStates,
    payouts,
    fleets,
    utils,
  },
});
